import { useContext } from 'react';
import { dataSelector } from '@nextiva/global-store';
import { useMutation } from 'react-query';
import { useSelector } from 'react-redux';
import { UserContext } from 'containers/pages/ManageUsers/usersContext';

import {
  updateCXUser,
  createCXUser,
} from 'services/CXWorkspaces/CXWorkspacesService';
import { GlobalStoreInterface } from 'interface/globalStore';

interface createUserPayload {
  userUuid: string;
  role: string;
}

export const useUpdateCXUser = () => {
  const globalStoreData: GlobalStoreInterface | undefined = useSelector(
    dataSelector,
  );
  const sso: string = globalStoreData?.sso;
  const corpAccountNumber: string =
    globalStoreData?.user?.accountInfo?.corpAcctNbr ??
    globalStoreData?.user?.profileDTO?.corpAcctNbr;

  return useMutation((userPayload) =>
    updateCXUser(sso, corpAccountNumber, userPayload),
  );
};

export const useCreateCXUser = () => {
  const globalStoreData: GlobalStoreInterface | undefined = useSelector(
    dataSelector,
  );
  const {
    userState: { newCXUserWorkspaces },
  } = useContext(UserContext);

  const sso: string = globalStoreData?.sso;
  const corpAccountNumber: string =
    globalStoreData?.user?.accountInfo?.corpAcctNbr ??
    globalStoreData?.user?.profileDTO?.corpAcctNbr;

  const payloadProfiles: number[] = [];
  newCXUserWorkspaces.forEach((workspace) => {
    payloadProfiles.push(workspace.id);
  });

  return useMutation(({ userUuid, role }: createUserPayload) =>
    createCXUser(sso, corpAccountNumber, payloadProfiles, userUuid, role),
  );
};
